import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'fi_FI',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '732ff4ce-f3c0-48d9-8783-27bb66c42c22',
  ''
);
